import { PlusOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import * as permissionKind from '../../../../shared/permissions';
import { useAccount } from '../../../components/contexts/AccountContextManager';
import ConsolePageWithHeader from '../../../layouts/ConsoleLayout/ConsolePageWithHeader';
import hasPermissions from '../../../utilities/hasPermissions';
import useGoTo from '../../../utilities/useGoTo';
import ConfiguratorList from './ConfiguratorList';

const ConfiguratorListPage = () => {
    const { t } = useTranslation('configuratorList');

    const goToNewConfiguratorPage = useGoTo('/admin/configurators/add');

    const { permissions: accountPermissions } = useAccount();

    const extra = hasPermissions(accountPermissions, [permissionKind.createConfigurator]) ? (
        <Button icon={<PlusOutlined />} onClick={goToNewConfiguratorPage} type="primary">
            {t('configuratorList:actions.newConfigurator')}
        </Button>
    ) : null;

    return (
        <ConsolePageWithHeader extra={extra} title={t('configuratorList:title')}>
            <ConfiguratorList />
        </ConsolePageWithHeader>
    );
};

export default ConfiguratorListPage;
